import axios from 'axios';

const api = axios.create({
 // baseURL: 'http://localhost:3000' // cambia a la IP de tu backend en la nube
  //baseURL: 'http://149.56.44.37:3000' 
  baseURL: 'https://agencianevadas.com/api',
});

function extractImageUrls(payload) {
  const data = payload?.data ?? payload;
  const raw =
    data?.urls ??
    data?.imagenes ??
    data?.images ??
    data?.photos ??
    data?.files ??
    [];

  if (!Array.isArray(raw)) return [];

  return raw
    .map((item) => {
      if (typeof item === 'string') return item;
      return item?.url || item?.secure_url || item?.path || '';
    })
    .filter(Boolean);
}

export async function uploadClientImages(files = []) {
  if (!Array.isArray(files) || files.length === 0) return [];

  const endpoint = process.env.VUE_APP_UPLOAD_IMAGES_ENDPOINT || '/uploads/images';
  const fieldName = process.env.VUE_APP_UPLOAD_FIELD_NAME || 'images';

  const formData = new FormData();
  files.forEach((file) => formData.append(fieldName, file));

  const response = await api.post(endpoint, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  const urls = extractImageUrls(response?.data);
  if (urls.length === 0) {
    throw new Error('No se recibieron URLs de imagen desde el servidor');
  }

  return urls;
}

export async function postCliente(payload, config = {}) {
  return api.post('/clientes', payload, config);
}

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    // algunos backends esperan el token en este header alternativo
    api.defaults.headers.common['x-access-token'] = token;
    console.log('[api] Authorization header set');
  } else {
    delete api.defaults.headers.common['Authorization'];
    delete api.defaults.headers.common['x-access-token'];
  }
}

export default api;
